import { render, staticRenderFns } from "./RoleStandards.vue?vue&type=template&id=f73bef90"
import script from "./RoleStandards.vue?vue&type=script&lang=js"
export * from "./RoleStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports